import _ from '@lodash';
import { AppBar, DialogContent, IconButton, Input, Paper, Toolbar, Typography, withStyles } from '@material-ui/core';
import XAPPDialog from 'app/Core/Components/Dialog/XAPPDialog';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import copy from "copy-to-clipboard";
import MobileDetect from 'mobile-detect';
import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { MdClose, MdContentCopy } from 'react-icons/md';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import XAPPButton from '../Button/XAPPButton';

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    root: {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    paper: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '20px',
        width: '95%',
        height: '48px',
    },
    iconButton: {
        padding: 10,
        textDecoration: 'none'
    }
});

class ViewUID extends XAPPComponent {

    state = {
        open: false
    }

    openDialog = (_AValue) => {
        this.setState(_.set({ ...this.state }, "open", _AValue));
    }

    render() {
        const { open } = this.state;
        const { classes, user } = this.props;
        return (
            <React.Fragment>
                <XAPPButton
                    className=""
                    type="icon"
                    key="lock"
                    tooltip={{ placement: "top", title: "ID do usuário" }}
                    color="action"
                    onClick={() => this.openDialog(true)}
                    icon={"userconfig"}
                    iconProps={"text-16 font-bold"}
                />
                <XAPPDialog
                    id="ViewUID"
                    open={open}
                    fullWidth
                    maxWidth="sm"
                    fullScreen={md.mobile() !== null}
                >
                    <AppBar position="static" elevation={1}>
                        <Toolbar className="flex w-full min-h-0">
                            <Typography variant="subtitle1 text-white">
                                {'ID do usuário'}
                            </Typography>
                            <div style={{ flex: 1 }} />
                            <IconButton
                                key="close"
                                aria-label="Close"
                                className="p-6"
                                onClick={() => this.openDialog(false)}
                            >
                                <MdClose className="text-20 text-white" />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <DialogContent classes={{ root: "p-24" }}>
                        <div className="flex flex-col items-center justify-center pb-4">
                            <Paper component="div" className={classes.paper}>
                                <Input
                                    placeholder="ID empresa"
                                    className="flex w-full pl-12"
                                    fullWidth
                                    disableUnderline
                                    name="idpessoa"
                                    value={user.usuario}
                                    type='text'
                                    disabled
                                />
                                <IconButton
                                    className={classes.iconButton}
                                    aria-label="search"
                                    onClick={() => copy(user.usuario)}
                                >
                                    <MdContentCopy />
                                </IconButton>
                                <IconButton
                                    href={"https://api.whatsapp.com/send?text=Olá, segue a chave do meu usuário HEXAPP: " + user.usuario}
                                    component="a"
                                    className={classes.iconButton}
                                    aria-label="search"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <FaWhatsapp />
                                </IconButton>
                            </Paper>
                        </div>
                    </DialogContent>
                </XAPPDialog>
            </React.Fragment>
        );
    }
}

function mapStateToProps({ auth }) {
    return {
        user: auth.user.data,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps)(ViewUID)));
